import { IReportsState } from './reportsState';
import { All as Actions } from './reportsActions';
import { ReportsConstants } from './reportsConstants';

const today = new Date();
const oneWeekBefore = new Date();
oneWeekBefore.setDate(today.getDate() - 7);

const initialState: IReportsState = {
  selectedTab: 0,
  isLoading: false,
  timeUsageReports: [],
  errorMsg: '',
  timeUsageReportFilter: {
    fromDate: oneWeekBefore,
    toDate: today,
    fractionIds: [],
    statusIds: [],
    contractorIds: [],
    routeIds: [],
  },
  isChartsVisible: false,
};

export function reports(state = initialState, action: Actions): IReportsState {
  switch (action.type) {
    case ReportsConstants.SET_ACTIVE_TAB: {
      return {
        ...state,
        selectedTab: action.payload,
      };
    }
    case ReportsConstants.GET_TIME_USAGE_REPORTS_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case ReportsConstants.GET_TIME_USAGE_REPORTS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        timeUsageReports: action.payload,
      };
    }
    case ReportsConstants.GET_TIME_USAGE_REPORTS_FAILURE: {
      return {
        ...state,
        isLoading: false,
        errorMsg: action.error.message,
      };
    }
    case ReportsConstants.SET_FILTER_VALUES:
      return {
        ...state,
        timeUsageReportFilter: action.payload,
      };
    case ReportsConstants.SET_CHARTS_VISIBILITY:
      return {
        ...state,
        isChartsVisible: action.payload,
      };
    default:
      return state;
  }
}
